import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../layouts/loader/Loadable.js";
import { getAuthToken, getUserProfile } from "../utils/_hooks/index.js";
import { useSelector } from "react-redux";
import CustomizeShop from "../screens/CustomizeShop/CustomizeShop.jsx";

/***** Layouts *****/
const FullLayout = Loadable(
  lazy(() => import("../layouts/FullLayout/FullLayout.js"))
);
const BlankLayout = Loadable(lazy(() => import("../layouts/BlankLayout.js")));

/***** Pages *****/
const Landing = Loadable(lazy(() => import("../screens/Landing/Landing.jsx")));
const Login = Loadable(
  lazy(() => import("../screens/Authentication/Login/login.jsx"))
);
const Dashboard = Loadable(
  lazy(() => import("../screens/Dashboard/Dashboard.jsx"))
);
const Restaurants = Loadable(
  lazy(() => import("../screens/Restaurants/View/Restaurants.jsx"))
);
const RestaurantCreate = Loadable(
  lazy(() => import("../screens/Restaurants/Create/RestaurantCreate.jsx"))
);
const RestaurantDetails = Loadable(
  lazy(
    () => import("../screens/Restaurants/DetailsView/RestaurantsDetails.jsx")
  )
);
const Subscriptions = Loadable(
  lazy(() => import("../screens/Subcriptions/Subscriptions.jsx"))
);
const Orders = Loadable(lazy(() => import("../screens/Orders/Orders.jsx")));
const Menu = Loadable(lazy(() => import("../screens/Menu/Menu.jsx")));
const Tables = Loadable(lazy(() => import("../screens/Tables/Tables.jsx")));
const Payments = Loadable(
  lazy(() => import("../screens/Payments/Payments.jsx"))
);
const Staffs = Loadable(lazy(() => import("../screens/Staffs/Staffs.jsx")));
const Leads = Loadable(
  lazy(() => import("../screens/Leads/SuperAdminLeads.jsx"))
);
const Reports = Loadable(lazy(() => import("../screens/Reports/Reports.jsx")));
const Settings = Loadable(
  lazy(() => import("../screens/Settings/Settings.jsx"))
);
const Support = Loadable(lazy(() => import("../screens/Support/Support.jsx")));
const Logout = Loadable(lazy(() => import("../screens/Logout/Logout.jsx")));

const Error = Loadable(lazy(() => import("../screens/404/404.js")));

/***** Custom Hook to Get Token *****/
const useAuthToken = () => {
  const localToken = getAuthToken();
  const reduxToken = useSelector((state) => state.authToken.token);
  return localToken || reduxToken;
};

/***** Routes Component *****/
const ThemeRoutes = () => {
  const authToken = useAuthToken();

  const navigateToDashboard = () => {
    if (getUserProfile() === "superAdmin") {
      return <Navigate to="/superadmin-dashboard" />;
    } else {
      return <Navigate to="/dashboard" />;
    }
  };

  return [
    {
      path: "/",
      element: authToken ? <FullLayout /> : <BlankLayout />,
      children: authToken
        ? [
            { path: "/", element: navigateToDashboard() },
            {
              path: "/superadmin",
              element: <Navigate to="/superadmin-dashboard" />,
            },

            //SuperAdmin
            { path: "/superadmin-dashboard", element: <Dashboard /> },
            { path: "/superadmin-restaurants", element: <Restaurants /> },
            {
              path: "/superadmin-restaurants/create",
              element: <RestaurantCreate />,
            },
            {
              path: "/superadmin-restaurants/:id",
              element: <RestaurantDetails />,
            },
            { path: "/superadmin-leads", element: <Leads /> },
            { path: "/superadmin-reports", element: <Reports /> },
            { path: "/superadmin-subscriptions", element: <Subscriptions /> },
            { path: "/superadmin-settings", element: <Settings /> },

            //Admin
            { path: "/dashboard", element: <Dashboard /> },
            { path: "/my-restaurant/:id", element: <RestaurantDetails /> },
            { path: "/customize-shop", element: <CustomizeShop /> },
            { path: "/orders", element: <Orders /> },
            { path: "/menu", element: <Menu /> },
            { path: "/tables", element: <Tables /> },
            { path: "/payments", element: <Payments /> },
            { path: "/staff", element: <Staffs /> },
            { path: "/reports", element: <Reports /> },
            { path: "/settings", element: <Settings /> },
            { path: "/support", element: <Support /> },

            //Common
            { path: "/logout", element: <Logout /> },
            { path: "/*", element: <Error /> },
          ]
        : [
            {
              path: "/superadmin",
              element: <Navigate to="/superadmin-login" />,
            },
            { path: "/superadmin-login", element: <Login /> },
            { path: "/login", element: <Login /> },
            { path: "/home", element: <Landing /> },
            { path: "", element: <Landing /> },
            { path: "/", element: <Landing /> },
            { path: "/*", element: <Landing /> },
          ],
    },
    {
      path: "/404",
      element: <Error />,
    },
  ];
};

export default ThemeRoutes;
